export default class UserAvatar {
  name: string;

  photo: string;

  constructor(obj?: any) {
    this.name = obj.name;
    this.photo = obj.photo;
  }

  public get formattedFullName(): string {
    const name = this.name.split(' ');
    return `${name[0]} ${name[name.length - 1]}`;
  }
}
